const storeDeliveryPossibleAreaMutationType = {
    SET_IS_DIALOG_OPEN: 'SET_IS_DIALOG_OPEN',
    // 가이아 데이터
    GET_SI_DO_LIST: 'GET_SI_DO_LIST',
    GET_SI_GUN_GU_LIST: 'GET_SI_GUN_GU_LIST',
    GET_EUP_MYEON_DONG_LIST: 'GET_EUP_MYEON_DONG_LIST',
    // 시도 시군구 선택
    SET_SI_DO: 'SET_SI_DO',
    SET_SI_GUN_GU: 'SET_SI_GUN_GU',
    // 가이아 데이터 리셋
    RESET_SI_DO_LIST: 'RESET_SI_DO_LIST',
    RESET_SI_GUN_GU_LIST: 'RESET_SI_GUN_GU_LIST',
    RESET_EUP_MYEON_DONG_LIST: 'RESET_EUP_MYEON_DONG_LIST',
    // 상점별 zoo 데이터
    GET_STORE_DELIVERY_POSSIBLE_AREA_LIST: 'GET_STORE_DELIVERY_POSSIBLE_AREA_LIST',
    RESET_STORE_DELIVERY_POSSIBLE_AREA_LIST: 'RESET_STORE_DELIVERY_POSSIBLE_AREA_LIST',
    // 등록/제외
    SET_DELIVERY_POSSIBLE_AREA_REGISTER: 'SET_DELIVERY_POSSIBLE_AREA_REGISTER',
    SET_DELIVERY_POSSIBLE_AREA_UNREGISTER: 'SET_DELIVERY_POSSIBLE_AREA_UNREGISTER',
    // 일괄 리셋
    RESET_DIALOG: 'RESET_DIALOG',
};
const storeDeliveryPossibleAreaActionType = {
    setIsDialogOpen: 'setIsDialogOpen',
    // 가이아 데이터
    getSiDoList: 'getSiDoList',
    getSiGunGuList: 'getSiGunGuList',
    getEupMyeonDongList: 'getEupMyeonDongList',
    // 시도 시군구 선택
    setSiDo: 'setSiDo',
    setSiGunGu: 'setSiGunGu',
    // 가이아 데이터 리셋
    resetSiDoList: 'resetSiDoList',
    resetSiGunGuList: 'resetSiGunGuList',
    resetEupMyeonDongList: 'resetEupMyeonDongList',
    // 상점별 zoo 데이터
    getStoreDeliveryPossibleAreaList: 'getStoreDeliveryPossibleAreaList',
    resetStoreDeliveryPossibleAreaList: 'resetStoreDeliveryPossibleAreaList',
    // 등록/제외
    _regist: '_regist',
    _unregist: '_unregist',
    setDeliveryPossibleAreaRegister: 'setDeliveryPossibleAreaRegister',
    setDeliveryPossibleAreaUnregister: 'setDeliveryPossibleAreaUnregister',
    // 전체 등록/제외
    setEveryDeliveryPossibleAreaRegister: 'setEveryDeliveryPossibleAreaRegister',
    setEveryDeliveryPossibleAreaUnregister: 'setEveryDeliveryPossibleAreaUnregister',
    // 배달 가능 동 등록/제외
    postDeliveryPossibleArea: 'postDeliveryPossibleArea',
    // 일괄 리셋
    resetDialog: 'resetDialog',
};
export { storeDeliveryPossibleAreaMutationType, storeDeliveryPossibleAreaActionType, };
